export default function timingMath(timing: PerformanceResourceTiming) {
  if (!timing) {
    return {};
  }
  // 总耗时
  const es = Math.round(timing.duration);
  // 下载耗时
  const tcd = timing.responseStart > 0 ? Math.round(
    timing.responseEnd - timing.responseStart) : 0;
  // dns耗时
  const dns = Math.round(timing.domainLookupEnd - timing.domainLookupStart);
  // tcp耗时
  const tcp = Math.round(timing.connectEnd - timing.connectStart);
  // 并发等待耗时
  const waited = Math.round(Math.max(timing.requestStart - timing.fetchStart - dns - tcp, 0));
  // 网络耗时
  const tnt = Math.round(es - waited);
  // 是否本地缓存
  const cacheType = (() => {
    if (['xmlhttprequest', 'fetch', 'iframe'].includes(timing.initiatorType)) {
      return 0;
    }
    return timing.transferSize === 0 ? 1 : (timing.transferSize === 300 ? 2 : 0);
  })();
  return { es, tcd, waited, tcp, dns, tnt, cacheType };
}
